// GTM Event: Dealer Account Application Form Submission
// Escucha envios del formulario Shopify Forms en /pages/dealer-account-application
// Form ID: 794445

(function() {
  const DEALER_ACCOUNT_FORM_ID = '794445';

  // Solo ejecutar en /pages/dealer-account-application
  if (!window.location.pathname.includes('/pages/dealer-account-application')) {
    return;
  }

  // Evita duplicados si el evento se dispara mas de una vez
  let dealerEventSent = false;
  const emailUtils = window.GTMEmailUtils || {};

  function pushDealerAccountEvent(source, detail) {
    if (dealerEventSent) return;

    const submittedFormId = String(detail?.form_id || detail?.id || '');

    // Si viene form_id, validamos que sea el formulario de dealer account
    if (submittedFormId && submittedFormId !== DEALER_ACCOUNT_FORM_ID) {
      return;
    }

    if (typeof window.dataLayer === 'undefined') {
      window.dataLayer = [];
    }

    const email =
      typeof emailUtils.getEventEmail === 'function'
        ? emailUtils.getEventEmail(detail)
        : '';

    window.dataLayer.push({
      event: 'dealer_account_form_submission',
      form_name: 'Apply for Dealer Account',
      form_id: DEALER_ACCOUNT_FORM_ID,
      submit_status: 'success',
      form_source: 'shopify_forms',
      page_type: 'dealer_account_application',
      page_path: window.location.pathname,
      trigger_source: source,
      email: email
    });

    dealerEventSent = true;
    console.log('Dealer Account form submitted (success)', { source: source, detail: detail });
  }

  // Shopify Forms puede emitir diferentes nombres de evento segun version/embed
  ['form_submitted', 'shopify:form_submitted', 'shopify:forms:submitted'].forEach(function(evtName) {
    window.addEventListener(evtName, function(event) {
      pushDealerAccountEvent(evtName, event?.detail || null);
    });

    document.addEventListener(evtName, function(event) {
      pushDealerAccountEvent(evtName + ':document', event?.detail || null);
    });
  });

  // Fallback para embeds en iframe que reportan exito via postMessage
  window.addEventListener('message', function(event) {
    if (dealerEventSent) return;

    const raw = event?.data;
    const text = typeof raw === 'string' ? raw : JSON.stringify(raw || {});
    const normalized = text.toLowerCase();

    const looksSuccessful =
      normalized.indexOf('submitted') !== -1 ||
      normalized.indexOf('success') !== -1 ||
      normalized.indexOf('completed') !== -1;

    if (!looksSuccessful) return;
    if (text.indexOf(DEALER_ACCOUNT_FORM_ID) === -1) return;

    pushDealerAccountEvent('postmessage_success', { form_id: DEALER_ACCOUNT_FORM_ID, raw: raw });
  });

  // Fallback: detectar envio exitoso por respuesta de red con referencia al form 794445
  function bodyContainsFormId(body) {
    if (!body) return false;
    if (typeof body === 'string') return body.indexOf(DEALER_ACCOUNT_FORM_ID) !== -1;

    try {
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        let found = false;
        body.forEach(function(value) {
          if (String(value).indexOf(DEALER_ACCOUNT_FORM_ID) !== -1) found = true;
        });
        return found;
      }

      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        return body.toString().indexOf(DEALER_ACCOUNT_FORM_ID) !== -1;
      }
    } catch (e) {
      return false;
    }

    return false;
  }

  function isLikelyShopifyFormSubmit(url) {
    if (!url) return false;
    const value = String(url).toLowerCase();
    return value.indexOf('shopify') !== -1 || value.indexOf('forms') !== -1;
  }

  if (typeof window.fetch === 'function') {
    const originalFetch = window.fetch;
    window.fetch = function(input, init) {
      const requestUrl = typeof input === 'string' ? input : (input && input.url) || '';
      const requestBody = (init && init.body) || '';

      return originalFetch.apply(window, arguments).then(function(response) {
        if (
          response &&
          response.ok &&
          isLikelyShopifyFormSubmit(requestUrl) &&
          bodyContainsFormId(requestBody)
        ) {
          pushDealerAccountEvent('fetch_success', {
            form_id: DEALER_ACCOUNT_FORM_ID,
            url: requestUrl,
            email:
              typeof emailUtils.getEventEmail === 'function'
                ? emailUtils.getEventEmail(null, requestBody)
                : ''
          });
        }

        return response;
      });
    };
  }
})();
